import React, { useState } from 'react';
import { Modal } from '../ui/Modal';
export function Footer() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="bg-slate-900 text-slate-400 py-12 text-center text-sm" data-id="element-30">
        <div className="container mx-auto px-4" data-id="element-31">
          <p className="mb-4" data-id="element-32">
            © {new Date().getFullYear()} Guía Anti-Sofocos. Todos los derechos
            reservados.
          </p>
          <p className="mb-6" data-id="element-33">
            Este producto no sustituye el consejo médico profesional.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-34">
            <button onClick={() => setShowPrivacy(true)} className="text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-35">
              Política de Privacidad
            </button>
            <span className="text-slate-600" data-id="element-36">·</span>
            <button onClick={() => setShowTerms(true)} className="text-slate-400 hover:text-white transition-colors underline underline-offset-2" data-id="element-37">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      <Modal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Política de Privacidad" data-id="element-38">
        <p data-id="element-39">
          <strong data-id="element-40">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-41">
          En Guía Anti-Sofocos, nos comprometemos a proteger tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-42">
          1. Información que recopilamos
        </h3>
        <p data-id="element-43">
          Recopilamos únicamente la información necesaria para procesar tu
          compra: nombre, dirección de correo electrónico y datos de pago. No
          almacenamos información de tarjetas de crédito en nuestros servidores.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-44">
          2. Uso de la información
        </h3>
        <p data-id="element-45">
          Tu información se utiliza exclusivamente para: procesar tu pedido,
          enviarte el producto digital adquirido y comunicarnos contigo sobre tu
          compra.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-46">
          3. Protección de datos
        </h3>
        <p data-id="element-47">
          Utilizamos medidas de seguridad estándar de la industria para proteger
          tu información personal. Toda la transmisión de datos se realiza
          mediante conexiones cifradas (SSL/TLS).
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-48">
          4. Compartir información
        </h3>
        <p data-id="element-49">
          No vendemos, intercambiamos ni transferimos tu información personal a
          terceros, excepto a proveedores de servicios de pago necesarios para
          completar tu transacción.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-50">
          5. Tus derechos
        </h3>
        <p data-id="element-51">
          Tienes derecho a acceder, corregir o eliminar tu información personal
          en cualquier momento.
        </p>
      </Modal>

      <Modal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Términos y Condiciones" data-id="element-52">
        <p data-id="element-53">
          <strong data-id="element-54">Última actualización:</strong> Febrero 2026
        </p>
        <p data-id="element-55">
          Al adquirir la Guía Anti-Sofocos Nocturnos en 7 Días, aceptas los
          siguientes términos y condiciones.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-56">
          1. Producto digital
        </h3>
        <p data-id="element-57">
          Este es un producto digital descargable en formato PDF. Una vez
          completada la compra, recibirás acceso inmediato a la descarga. No se
          realizan envíos físicos.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-58">
          2. Uso personal
        </h3>
        <p data-id="element-59">
          La guía es para uso personal únicamente. Queda prohibida su
          reproducción, distribución o reventa sin autorización expresa.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-60">
          3. Descargo de responsabilidad médica
        </h3>
        <p data-id="element-61">
          Este producto es informativo y educativo. No sustituye el consejo,
          diagnóstico o tratamiento médico profesional. Consulta siempre con tu
          médico antes de realizar cambios en tu rutina de salud.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-62">
          4. Resultados
        </h3>
        <p data-id="element-63">
          Los resultados pueden variar de persona a persona. No garantizamos
          resultados específicos, ya que dependen de factores individuales y del
          compromiso con el programa.
        </p>
        <h3 className="font-bold text-slate-900 text-base mt-4" data-id="element-64">
          5. Propiedad intelectual
        </h3>
        <p data-id="element-65">
          Todo el contenido de la guía está protegido por derechos de autor. El
          uso no autorizado constituye una violación de las leyes de propiedad
          intelectual aplicables.
        </p>
      </Modal>
    </>;
}